import { render, staticRenderFns } from "./cxp.vue?vue&type=template&id=72971a32&"
import script from "./cxp.vue?vue&type=script&lang=js&"
export * from "./cxp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports